import { RoadmapBaseEvent } from '@/typings/api/RoadmapBaseEvent'

// import { dateFormatter } from '@/helpers/dateFormatter'
import { EDIT, VIEW, DELETE } from '@/helpers/enums/table-actions'


export const TABLE_ACTIONS = Object.freeze([
  EDIT,
  VIEW,
  DELETE,
])

export const TABLE_HEADERS = Object.freeze([
  {
    text: 'Название',
    value: 'name',
    sortable: false,
  },
  {
    text: 'Типы файлов',
    value: 'file_types',
    sortable: false,
  },
  {
    text: 'Макс. размер файла',
    value: 'max_file_size',
    sortable: false,
    width: 120,
    field: (size: RoadmapBaseEvent['max_file_size']) => size && `${size} Mb`,
  },
  {
    text: 'Кол-во файлов',
    value: 'max_file_count',
    sortable: false,
    width: 100,
  },
  /*
  {
    text: 'Дата изменения',
    value: 'updated_at',
    sortable: false,
    width: 130,
    field: (value: RoadmapBaseEvent['updated_at']) => (
      value && dateFormatter(value)
    ),
  },
  {
    text: 'Дата создания',
    value: 'created_at',
    sortable: false,
    width: 130,
    field: (value: RoadmapBaseEvent['created_at']) => (
      value && dateFormatter(value)
    ),
  },
  */
])
